import React, { useEffect } from "react"
import { PageName } from "ui/PageName"
import { Flex } from "antd"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getQuestionnaireTemplateById } from "store/question"
import FirstLoading from "modules/loader-watchers/FirstLoading"
import CustomQuestions from "./CustomQuestions"
export const TemplateDetails = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const templateDetail = useSelector((state) => state.question.currentTemplate.data)
  const loading = useSelector((state) => state.question.currentTemplate.loading)
  const templateQuestions = useSelector((state) => state.question.templateQuestions.data)
  useEffect(() => {
    if (id) {
      dispatch(getQuestionnaireTemplateById(id))
    }
  }, [id, dispatch])
  return (
    <FirstLoading loading={loading}>
      <PageName title="Template Details" />
      <Flex align="center" justify="space-between"></Flex>
      <CustomQuestions
        experienceList={templateDetail?.experience_list}
        description={id && templateDetail?.description}
        trips={id && templateDetail?.trips}
        title={id && templateDetail?.name}
        templateId={id}
        templateQuestions={id && templateQuestions}
      />
    </FirstLoading>
  )
}
